import {
  GET_INDUSTRY_CATEGORY_LIST_REQUEST,
  GET_INDUSTRY_CATEGORY_LIST_SUCCESS,
  GET_INDUSTRY_CATEGORY_LIST_FAILURE,
} from '../../constants/ActionTypes';
import { IndustryCategoryApi } from '../api/IndustryCategoryApi';

export const getIndustryCategoryListRequest = () => ({
  type: GET_INDUSTRY_CATEGORY_LIST_REQUEST,
});

export const getIndustryCategoryListSuccess = (data) => ({
  type: GET_INDUSTRY_CATEGORY_LIST_SUCCESS,
  payload: {
    industryCategoryList: data,
  },
});

export const getIndustryCategoryListFailure = (error) => ({
  type: GET_INDUSTRY_CATEGORY_LIST_FAILURE,
  payload: {
    error: error,
  },
});

export const getIndustryCategoryList = (data) => {
  return (dispatch) => {
    dispatch(getIndustryCategoryListRequest());
    IndustryCategoryApi.getIndustryCategoryList(data, dispatch)
      .then((response) => {
        dispatch(getIndustryCategoryListSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getIndustryCategoryListFailure(error.response));
      });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/IndustryCategory.js